// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'staging',
  hostUrl: 'https://staging-be.tecprotec.co',
  SERVICE_PORTAL_LINK: 'https://tecprotec-staging.device.bolttech.vn/service-request/portal?realm=67d76154-156a-4e60-b339-1de29081c7af',
  customerPortalBaseUrl: 'https://tecprotec-staging.device.bolttech.vn/service-request/', //Development Server
  SERVICE_DELIVERY_URL: 'https://staging.tecprotec.co/id/servicedelivery',
  HOW_IT_WORK_VIDEO_MP4: 'https://download.stage.device.bolttech.vn/Tecprotect-video_v3.mp4',
  HOW_IT_WORK_VIDEO_WEBM: 'https://download.stage.device.bolttech.vn/Tecprotect-video_v3.webm',
  PHONE_PACKING_VIDEO_MP4: 'https://download.stage.device.bolttech.vn/Phone-Packing-Tecprotec-v10.mp4',
  PHONE_PACKING_VIDEO_WEBM: 'https://download.stage.device.bolttech.vn/Phone-Packing-Tecprotec-v10.webm',
  GTM_ID: 'GTM-M7MC8GK'
};



// WEBPACK FOOTER //
// ./src/app/environments/environment.ts